import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { AreaMenuIconComponent } from './AreaMenuIconComponent';

@NgModule({
    declarations: [
        AreaMenuIconComponent
    ],
    entryComponents: [
        AreaMenuIconComponent
    ],
    exports: [
        AreaMenuIconComponent
    ],
    imports: [
        CommonModule,
        MatIconModule
    ],
})
export class AreaMenuIconModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            AreaMenuIconComponent
        ]);
    }
}
